export default __webpack_public_path__ + "graphics/shirt.d73c8482.jpg";